export const UPDATE_NAME_ON_CARD = 'CreateInvitationReview/*/UpdateNameOnCard';
export const UPDATE_CARD_NUMBER_LAST_FOUR = 'CreateInvitationReview/*/UpdateCardNumberLastFour';
export const UPDATE_CARD_ENCRYPTED = 'CreateInvitationReview/*/UpdateCardEncrypted';
export const UPDATE_CARD_NUMBER_FILLED = 'CreateInvitationReview/*/UpdateCardNumberFilled';
export const UPDATE_CARD_EXP_DATE_FILLED = 'CreateInvitationReview/*/UpdateCardExpirationDate';
export const UPDATE_CARD_CVC_FILLED = 'CreateInvitationReview/*/UpdateCardSecurityCode';
export const UPDATE_BILLING_ZIP = 'CreateInvitationReview/*/UpdateBillingZIP';
export const SET_PAYMENT_FORM_VALIDITY = 'CreateInvitationReview/*/SetPaymentFormValidity';
export const TOGGLE_PROMO_CODE = 'CreateInvitationReview/*/TogglePromoCode';
export const INIT_OFFERS = 'CreateInvitationReview/*/InitOffers';
export const SET_CALC = 'CreateInvitationReview/*/SetCalc';
export const TOGGLE_USE_EXISTING_PAYMENT = 'CreateInvitationReview/*/ToggleUseExistingPayment';
export const SET_PAYMENT_METHOD = 'CreateInvitationReview/*/SetPaymentMethod';
export const UPDATE_REVIEW = 'CreateInvitationReview/*/UpdateReview';
export const SHAREABLE_LINK_PREMIUM_UPSELL = 'CreateInvitationReview/*/ShareableLinkPremiumUpsell';
export const SET_USE_EXISTING_PAYMENT = 'CreateInvitationReview/*/SetUseExistingPayment';

export const TOGGLE_DELIVER_CARD_NOW = 'CreateGreetingCard/*/ToggleDeliverCardNow';
export const UPDATE_DELIVER_CARD_DATE_TIME = 'CreateGreetingCard/*/UpdateDeliverCardDateTime';

export const UPDATE_DELIVER_CARD_TIMEZONE = 'CreateGreetingCard/*/UpdateDeliverCardTimeZone';

export const UPDATE_SENDER = 'CreateGreetingCard/*/UpdateSender';
export const GREETING_CARD_CHECKED_OUT = 'CreateGreetingCard/*/CheckedOut';
export const RESET_REVIEW = 'CreateGreetingCard/*/ResetReview';
export const GREETING_CARD_E_GIFT_CHECKED_OUT = 'CreateGreetingCard/*/EGiftCardCheckedOut';
